import {
  addProductsToCart,
  addToComponent,
  eliminateDuplicateProducts,
  emptyCart,
  getCart,
  removeComponent,
  removeProduct,
  removeToComponent
} from '../../controllers/cartController'
import {
  addNewUserAddress,
  deleteNewUserAddress,
  getUserAddressById,
  getUserAddresses,
  getUserData,
  loginUser,
  registerUser,
  updateUserAddress,
  updateUserAddressById,
  updateUserTransport,
  resetPassword,
  changePassword
} from '../../controllers/accountController'
import {
  addShipmentCost,
  confirmOrder,
  deliveryTime,
  getBanks,
  getPaymentMethods,
  getShipmentCost,
  sendPaymentMethod,
  sendShippingMethod
} from '../../controllers/checkoutController'
import {
  getSliders,
  getCategories,
  getColors,
  getDolarValue,
  getMostSalesProducts,
  getProductsByCategory,
  getProductsById,
  getProductsSearched,
  getSizes
  // getDownloadPricesList,
} from '../../controllers/productsController'
import {
  getCarriers,
  getShipmentInfo,
  getStates
} from '../../controllers/utilitiesController'
import {
  getInvoice,
  getLatestOrders,
  getOrderById
} from '../../controllers/ordersController'
import { getDownloadPricesList } from '../../controllers/exportController'
import { getBanners } from '../../controllers/bannersController'

const apiInstance = {
  apiURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
}

export const setApiURL = (url) => {
  apiInstance.apiURL = url
}

export const api = {
  categories: { listAll: () => getCategories(apiInstance) },
  banners: { getBanners: () => getBanners(apiInstance) },
  products: {
    listSliders: () => getSliders(apiInstance),
    listMostSales: (id) => getMostSalesProducts(apiInstance, id),
    listByCategory: (url, signal) =>
      getProductsByCategory(apiInstance, url, signal),
    dolarValue: () => getDolarValue(apiInstance),
    listById: (idClient, idProduct) =>
      getProductsById(apiInstance, idClient, idProduct),
    listProductsSearched: (url, signal) =>
      getProductsSearched(apiInstance, url, signal),
    listColors: () => getColors(apiInstance),
    listSizes: () => getSizes(apiInstance)
  },
  checkout: {
    getShipmentCost: (clientPriceListId) =>
      getShipmentCost(apiInstance, clientPriceListId),
    addShipmentCost: (data, shipmentCost) =>
      addShipmentCost(apiInstance, data, shipmentCost),
    deliveryTime: () => deliveryTime(apiInstance),
    shippingMethod: (clientId, method, address, date, data) =>
      sendShippingMethod(apiInstance, clientId, method, address, date, data),
    getPaymentMethods: () => getPaymentMethods(apiInstance),
    getBanks: () => getBanks(apiInstance),
    paymentMethod: (id, method, discount, data) =>
      sendPaymentMethod(apiInstance, id, method, discount, data),
    confirm: (data) => confirmOrder(apiInstance, data)
  },
  account: {
    login: (user, password) => loginUser(apiInstance, user, password),
    registerUser: (data) => registerUser(apiInstance, data),
    getUserData: (docNumber) => getUserData(apiInstance, docNumber),
    updateUserAddress: (data) => updateUserAddress(apiInstance, data),
    updateUserTransport: (data) => updateUserTransport(apiInstance, data),
    getUserAddresses: (data) => getUserAddresses(apiInstance, data),
    getUserAddressById: (userId, addressId) =>
      getUserAddressById(apiInstance, userId, addressId),
    addNewUserAddress: (data) => addNewUserAddress(apiInstance, data),
    updateUserAddressById: (data, addressId) =>
      updateUserAddressById(apiInstance, data, addressId),
    deleteNewUserAddress: (userId, addressId) =>
      deleteNewUserAddress(apiInstance, userId, addressId),
    resetPassword: (data) => resetPassword(apiInstance, data),
    changePassword: (currentPassword, newPassword, userId, userEmail) =>
      changePassword(
        apiInstance,
        currentPassword,
        newPassword,
        userId,
        userEmail
      )
  },
  cart: {
    getCart: (data) => getCart(apiInstance, data),
    eliminateDuplicateProducts: (idClient, clientPriceListId) =>
      eliminateDuplicateProducts(apiInstance, idClient, clientPriceListId),
    addProducts: (data) => addProductsToCart(apiInstance, data),
    removeComponent: (idComponent, data) =>
      removeComponent(apiInstance, idComponent, data),
    removeProduct: (idProduct, data) =>
      removeProduct(apiInstance, idProduct, data),
    addToComponent: (idComponent, data) =>
      addToComponent(apiInstance, idComponent, data),
    removeToComponent: (idComponent, data) =>
      removeToComponent(apiInstance, idComponent, data),
    emptyCart: (data) => emptyCart(apiInstance, data)
  },
  orders: {
    getLatestOrders: (clientId, statusCode = '') =>
      getLatestOrders(apiInstance, clientId, statusCode),
    getOrderById: (clientId, orderId) =>
      getOrderById(apiInstance, clientId, orderId),
    getInvoice: (orderId) => getInvoice(apiInstance, orderId)
  },
  utilities: {
    getCarriers: () => getCarriers(apiInstance),
    getStates: (signal) => getStates(apiInstance, signal),
    getShipmentInfo: () => getShipmentInfo(apiInstance)
  },
  export: {
    listPrices: (clientPriceListId) =>
      getDownloadPricesList(apiInstance, clientPriceListId)
  }
}
